import styled, { keyframes } from 'styled-components';
import { NavLink } from 'react-router-dom';

const HeaderStyled = styled.header`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: ${props => props.theme.header.height};
  justify-content: center;
  margin: 0;
  overflow: hidden;
  position: fixed;
  text-align: center;
  top: 0;
  width: 100%;
  z-index: ${props => props.theme.zIndex.header};

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    height: ${props => props.theme.header.heightLarge};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    height: ${props => props.theme.header.heightXLarge};
  }

  .fade-enter & {
    opacity: 0.01;
    transform: translateY(20px);
  }

  .fade-enter-active & {
    opacity: 1;
    transform: translateY(0%);
    transition: all 300ms ease-out;
  }

  .fade-exit & {
    opacity: 1;
    transform: translateY(0%);
  }

  .fade-exit-active & {
    opacity: 0.01;
    transform: translateY(20px);
    transition: all 300ms ease-out;
  }
`;

const animatePath = keyframes`
    0%, 99% {
        stroke-dashoffset: ${props => props.pathLength};
    }

    100% {
        stroke-dashoffset: 0;
    }
`;

export const SVGLogoPath = styled.svg`
  animation: ${animatePath} ${props => props.theme.logo.duration}
    ${props => props.theme.transition.easeOut} infinite;
  fill: none;
  height: ${props => props.theme.logo.height};
  margin: 0 2px;
  overflow: visible;
  position: relative;
  stroke-dasharray: ${props => props.pathLength},
    ${props => props.pathLength / 2}, ${props => props.pathLength};
  stroke-dashoffset: ${props => props.pathLength + props.pathLength / 2};
  stroke-linecap: ${props => props.theme.logo.strokeLinecap};
  stroke-miterlimit: 10;
  stroke-width: ${props => props.theme.logo.strokeWidth};
  stroke: ${props => props.theme.logo.stroke};
  top: -1px;
  width: ${props => props.theme.logo.width};
`;

export const HomeLink = styled(NavLink)`
  color: ${props =>
    props.open ? props.theme.colors.tertiary : props.theme.colors.white};
  font-weight: 600;
  padding: 0;
  position: relative;
  z-index: ${props => props.theme.zIndex.logo};
`;

export const HeaderNav = styled.nav`
  align-items: center;
  background: ${props => props.theme.nav.bg};
  bottom: 0;
  display: none;
  justify-content: center;
  left: 0;
  opacity: 0;
  position: fixed;
  right: 0;
  top: 0;
  transition: opacity ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeInOut},
    transform ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeInOut};

  &.header-nav-enter,
  &.header-nav-exit-active {
    background: ${props => props.theme.nav.bg};
    display: flex;
    opacity: 0;
    transform: translateY(-100vh);
  }

  &.header-nav-enter-active,
  &.header-nav-enter-done,
  &.header-nav-exit {
    display: flex;
    opacity: 1;
    transform: translateY(0);
  }

  &.header-nav-exit-active {
    opacity: 0;
    transform: translateY(-100vh);
  }

  &.header-nav-exit-done {
    display: none;
  }
`;

export const HeaderNavUl = styled.ul`
  align-items: center;
  display: flex;
  flex-direction: column;
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export const HeaderNavLi = styled.li`
  list-style-type: none;

  a,
  a:visited {
    align-items: center;
    color: ${props => props.theme.colors.tertiary};
    display: flex;
    flex-direction: row;
    font-size: calc(${props => props.theme.fonts.baseSize} + 1vmin);
    font-weight: 600;
    justify-content: center;
    letter-spacing: 1px;
    position: relative;
    text-transform: uppercase;
    transition: color ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeInOut};

    &.active::after {
      content: '';
      border-top: calc(2px + 0.2vmin) solid
        ${props => props.theme.colors.primary};
      position: absolute;
      bottom: -10px;
      width: 20px;
      left: 50%;
      transform: translateX(-50%);
      transition: width ${props => props.theme.transition.durationLong}
          ${props => props.theme.transition.easeInOut},
        border-color ${props => props.theme.transition.durationLong}
          ${props => props.theme.transition.easeInOut};
    }

    &:hover {
      color: ${props => props.theme.colors.primary};

      &.active::after {
        border-color: ${props => props.theme.colors.tertiary};
        width: 30px;
      }
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    a:link,
    a:visited {
      font-size: calc(${props => props.theme.fonts.baseSize} + 2vmin);
    }
  }
`;

export const Copyright = styled.a`
  bottom: 10px;
  height: 25px;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  width: 25px;

  svg {
    fill: ${props => props.theme.colors.tertiary};
    width: 25px;
  }

  &:hover svg {
    fill: ${props => props.theme.colors.orange};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    bottom: 30px;
  }
`;

export default HeaderStyled;



// WEBPACK FOOTER //
// ./src/components/molecules/Header/Header.styled.js